import React from "react";
import TabPages from "../components/TabPages";
import Reports from "./Reports";
import Chargeback from "./Chargeback";

export default function ReportCenter() {
  return (
    <TabPages
      testId="report-center-page"
      tabPrefix="rc"
      defaultTab="reports"
      tabs={[
        { id: "reports", label: "Reports", render: () => <Reports /> },
        { id: "chargeback", label: "Chargeback Automation", render: () => <Chargeback /> },
      ]}
    />
  );
}
